// extracted by mini-css-extract-plugin
module.exports = {"warning":"_7a3fb80146--warning--FextH","warn":"_7a3fb80146--warn--BrNd0","label":"_7a3fb80146--label--ZzAdx"};